




import Profile from '../components/Profile.vue'
import { Vue, Component, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import { Debounce } from '@/modules/core/utils/decorators'

@Component({
  components: { Profile }
})
export default class ProfileView extends Vue {

}
